import { render, staticRenderFns } from "./resolutions.vue?vue&type=template&id=ab1f11b4&"
import script from "./resolutions.vue?vue&type=script&lang=js&"
export * from "./resolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports